var _toConsumableArray = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/createClass");

/*
class MultiMapTree:
  Method:
    // iterator
    begin
    end
    rbegin
    rend
    [Symbol.iterator]

    // Capacity
    empty
    size

    // Modifiers
    clear
    insert
    erase
    assign
    insertOrAssign

    // Lookup
    count
    find
    contains
    equalRange
    lowerBound
    upperBound

    // Observers
    keyComp

    //
    toString
*/
var RedBlackTree = require('./redBlackTree');
/**
 * @classdesc self-balancing binary search tree.<br>
 * key - value mapping.<br>
 * Use composition by RedBlackTree.<br>
 * Can not have mutiple same element.
 */


var MultiMapTree =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Initiate MultiMapTree.<br>
   * Get parameter as null or compare function or other set tree.
   * @param {null|function|MultiMapTree} data
   */
  function MultiMapTree() {
    var _this = this;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, MultiMapTree);

    /**
     * compose red black tree.
     * @type {RedBlackTree}
     * @private
     */
    this._tree = new RedBlackTree();

    if (typeof data === 'function') {
      this._tree = new RedBlackTree(data);
    } else if (data instanceof MultiMapTree) {
      this._tree = new RedBlackTree(data.keyComp());

      _toConsumableArray(data).forEach(function (val) {
        return _this._tree.insert(val[0], val[1]);
      });
    }
  }
  /**
   * Return the first iterator node of tree.
   * @returns {null|TreeNode}
   */


  _createClass(MultiMapTree, [{
    key: "begin",
    value: function begin() {
      return this._tree.begin();
    }
    /**
     * this express the end of iterating.<br>
     * we can start from front with begin(), end with rbegin() and eventually meet end()<br>
     * At the end, if we use getNext() method, we get false.<br>
     * But, if we use getPrev() method, we get maximum node.
     * @return {TreeNode} - endnode of tree iterator.
     */

  }, {
    key: "end",
    value: function end() {
      return this._tree.end();
    }
    /**
     * return the last node of tree iterator.
     * @returns {null|TreeNode}
     */

  }, {
    key: "rbegin",
    value: function rbegin() {
      return this._tree.rbegin();
    }
    /**
     * this express the front end of iterating.<br>
     * we can start from front with begin(), end with rbegin() and eventually meet end()<br>
     * At the end, if we use getNext() method, we get false.<br>
     * But, if we use getPrev() method, we get maximum node.
     * @return {TreeNode} - endnode of tree iterator.
     */

  }, {
    key: "rend",
    value: function rend() {
      return this._tree.rend();
    }
    /**
     * iterator of tree.<br>
     * return value is [key, value] array.
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      var itr = this._tree[Symbol.iterator]();

      var data = null;
      var iterator = {
        next: function next() {
          data = itr.next();

          if (data.done === false) {
            return {
              value: data.value,
              done: false
            };
          }

          return {
            value: undefined,
            done: true
          };
        }
      };
      return iterator;
    }
    /**
     * make sure tree is empty.
     * @returns {boolean}
     */

  }, {
    key: "empty",
    value: function empty() {
      return this._tree.empty();
    }
    /**
     * the number of nodes in tree.
     * @returns {number}
     */

  }, {
    key: "size",
    value: function size() {
      return this._tree.size();
    }
    /**
     * initiate the tree.
     */

  }, {
    key: "clear",
    value: function clear() {
      this._tree.clear();
    }
    /**
     * insert new node in tree with key.<br>
     * @param {*} key - Should not TreeNode.
     * @param {*} value
     */

  }, {
    key: "insert",
    value: function insert(key, value) {
      this._tree.insert(key, value);

      return true;
    }
    /**
     * If erase() get key value as param, we erase all nodes with that key.<br>
     * But if erase() get TreeNode as param, we erase only that node.
     * @param {*|TreeNode} data - Data can be key or Node of tree.
     * @returns {false|TreeNode} - next node of erased data. if cannot find the key, return falase.
     */

  }, {
    key: "erase",
    value: function erase(data) {
      return this._tree.erase(data);
    }
    /**
     * Assign new value to given key.<br>
     * If key node is several, change all the data.
     * If key is not in tree, return false.
     * @param {*} key - Should not TreeNode.
     * @param {*} value
     * @returns {boolean}
     */

  }, {
    key: "assign",
    value: function assign(key, value) {
      var range = this._tree.equalRange(key);

      if (range[0] === this.end()) {
        return false;
      }

      for (var itr = range[0]; itr !== range[1]; itr = itr.getNext()) {
        itr.setValue(value);
      }

      return true;
    }
    /**
     * Insert new key and value.<br>
     * If key already exists in tree, assign the value to that key.
     * @param {*} key - Should not TreeNode.
     * @param {*} value
     */

  }, {
    key: "insertOrAssign",
    value: function insertOrAssign(key, value) {
      if (this.contains(key)) {
        this.assign(key, value);
      } else {
        this.insert(key, value);
      }
    }
    /**
     * count the number of nodes which match the key.<br>
     * @param {*} key - Should not TreeNode.
     * @returns {number}
     */

  }, {
    key: "count",
    value: function count(key) {
      return this._tree.count(key);
    }
    /**
     * return arbitrary node which matches the key.
     * @param {*} key - Should not TreeNode.
     * @returns {TreeNode}
     */

  }, {
    key: "find",
    value: function find(key) {
      return this._tree.find(key);
    }
    /**
     * make sure the key is in tree.
     * @param {*} key - Should not TreeNode.
     * @returns {boolean}
     */

  }, {
    key: "contains",
    value: function contains(key) {
      return this._tree.contains(key);
    }
    /**
     * return the start node and end node of given key.<br>
     * end node is next node of last match node.<br>
     * if no key in tree, return [endnode,endnode]
     * @param {*} key - Should not TreeNode.
     * @returns {Array} - [TreeNode,TreeNode]
     */

  }, {
    key: "equalRange",
    value: function equalRange(key) {
      return this._tree.equalRange(key);
    }
    /**
     * Find the first not less node.<br>
     * It don't need to be same with given key.
     * @param {*} key - the target key to find.
     * @returns {TreeNode}
     */

  }, {
    key: "lowerBound",
    value: function lowerBound(key) {
      return this._tree.lowerBound(key);
    }
    /**
     * Find the first upper node.<br>
     * @param {*} key - the target key to find.
     * @returns {TreeNode}
     */

  }, {
    key: "upperBound",
    value: function upperBound(key) {
      return this._tree.upperBound(key);
    }
    /**
     * return the key compare function.
     * @returns {function}
     */

  }, {
    key: "keyComp",
    value: function keyComp() {
      return this._tree.keyComp();
    }
    /**
     * show information of object
     * @returns {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      var str = "Object Name: MultiMapTree\nSize: ".concat(this.size().toString()).concat("\nElements: ");

      _toConsumableArray(this).map(function (d, i) {
        str = str.concat("\n  Sequence[").concat(i).concat("]:\n    key: ").concat(d[0].toString()).concat("\n    value: ").concat(d[1].toString());
        return true;
      });

      return str;
    }
  }]);

  return MultiMapTree;
}();

module.exports = MultiMapTree;